import { render, staticRenderFns } from "./MarketingMaterialList.vue?vue&type=template&id=9b0f9ff6&scoped=true"
import script from "./MarketingMaterialList.js?vue&type=script&lang=js&external"
export * from "./MarketingMaterialList.js?vue&type=script&lang=js&external"
import style0 from "./MarketingMaterialList.scss?vue&type=style&index=0&id=9b0f9ff6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0f9ff6",
  null
  
)

export default component.exports